// in ActionProvider.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';

const ActionProvider = ({ createChatBotMessage, setState, children }: any) => {
    const { t } = useTranslation();

    const handelChoise = () => {
        const botMessage = createChatBotMessage(
            t('chatbot.deptchoise'),
            {
                widget: 'departmentChoise'
            }
        );


        setState((prev: any) => ({
            ...prev,
            messages: [...prev.messages, botMessage],
        }));
    }

    return (
        <div>
            {React.Children.map(children, (child) => {
                return React.cloneElement(child, {
                    actions: {
                        
                        handelChoise,

                    },
                });
            })}
        </div>
    );
};

export default ActionProvider;